export const FORGOT_API_STARTED = 'cboard/ResetPassword/FORGOT_API_STARTED';
export const FORGOT_API_SUCCESS = 'cboard/ResetPassword/FORGOT_API_SUCCESS';
export const FORGOT_API_FAILURE = 'cboard/ResetPassword/FORGOT_API_FAILURE';
